.UnitHealthBar {
  overflow: hidden;
  background-color: #f0ead6;
  position: relative;
  border-width: 0.05em;
  border-color: #111111;
  border-style: solid;
  z-index: 0;
}
.UnitHealthBar .Label {
  left: 0em;
  right: 0em;
  top: -0.5em;
  bottom: -0.5em;
  z-index: 100000;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}
.UnitHealthBar .Label span {
  font-size: 0.5em;
  text-stroke: 0.25em #051F29;
  -ms-text-stroke: 0.25em #051F29;
  -moz-text-stroke: 0.25em #051F29;
  -webkit-text-stroke: 0.25em #051F29;
  paint-order: stroke fill;
}
.UnitHealthBar .Bar {
  overflow: hidden;
  width: 100%;
  height: 100%;
}
.UnitHealthBar .Fill {
  width: 0%;
  height: 100%;
  z-index: 10;
  position: absolute;
  background-color: #d54b33;
  transition-property: width;
  transition-duration: 0.1s;
}
.UnitHealthBar .Fill[isBig] {
  background-color: #862b1c;
}
.UnitHealthBar .OmegaFill {
  width: 0%;
  height: 100%;
  z-index: 20;
  position: absolute;
  background-color: #f0ead6;
  animation-iteration-count: infinite;
}
.UnitHealthBar .OmegaFill[color=heal] {
  animation-duration: 1s;
  animation-name: pulse-white;
}
@keyframes pulse-white {
  0% {
    background-color: #f0ead6;
  }
  25% {
    background-color: #f0ead6;
  }
  50% {
    background-color: #d54b33;
  }
  75% {
    background-color: #f0ead6;
  }
  100% {
    background-color: #f0ead6;
  }
}
.UnitHealthBar .OmegaFill[color=hurt] {
  animation-duration: 2s;
  animation-name: pulse-red;
}
@keyframes pulse-red {
  0% {
    background-color: #d54b33;
  }
  25% {
    background-color: #d54b33;
  }
  50% {
    background-color: #f0ead6;
  }
  75% {
    background-color: #d54b33;
  }
  100% {
    background-color: #d54b33;
  }
}
.UnitHealthBar .Borders {
  top: 0em;
  left: 0em;
  bottom: 0em;
  right: 0em;
  z-index: 30;
  max-width: 100%;
  position: absolute;
  display: flex;
}
.UnitHealthBar .Borders .Border {
  flex: 1;
}
.UnitHealthBar .Borders .Border:not(:last-child) {
  border-right-width: 0.05em;
  border-right-style: solid;
  border-right-color: #111111;
}
[gamekey=ember] .UnitHealthBar {
  height: 0.12em !important;
  border-radius: 0.2em;
  border-width: 0.03em;
  border-color: #051F29;
  background-color: #080809;
}
[gamekey=ember] .UnitHealthBar .Border:not(:last-child) {
  border-right-width: 0.03em;
  border-right-color: #051F29;
}
[gamekey=ember] .UnitHealthBar .Fill {
  background-color: #24AA69;
}
[gamekey=ember] .UnitHealthBar .Fill .OmegaFill[color=heal] {
  animation-duration: 1s;
  animation-name: pulse-ember-neutral-heal;
}
@keyframes pulse-ember-neutral-heal {
  0% {
    background-color: #f0ead6;
  }
  25% {
    background-color: #f0ead6;
  }
  50% {
    background-color: #61DEA1;
  }
  75% {
    background-color: #f0ead6;
  }
  100% {
    background-color: #f0ead6;
  }
}
[gamekey=ember] .UnitHealthBar .Fill .OmegaFill[color=hurt] {
  animation-duration: 2s;
  animation-name: pulse-ember-neutral-hurt;
}
@keyframes pulse-ember-neutral-hurt {
  0% {
    background-color: #61DEA1;
  }
  25% {
    background-color: #61DEA1;
  }
  50% {
    background-color: #f0ead6;
  }
  75% {
    background-color: #61DEA1;
  }
  100% {
    background-color: #61DEA1;
  }
}
[gamekey=ember] .UnitHealthBar .Fill {
  background-color: #E86C3B;
}
[gamekey=ember] .UnitHealthBar .OmegaFill[color=heal] {
  animation-duration: 1s;
  animation-name: pulse-ember-good-heal;
}
@keyframes pulse-ember-good-heal {
  0% {
    background-color: #f0ead6;
  }
  25% {
    background-color: #f0ead6;
  }
  50% {
    background-color: #FF954C;
  }
  75% {
    background-color: #f0ead6;
  }
  100% {
    background-color: #f0ead6;
  }
}
[gamekey=ember] .UnitHealthBar .OmegaFill[color=hurt] {
  animation-duration: 2s;
  animation-name: pulse-ember-good-hurt;
}
@keyframes pulse-ember-good-hurt {
  0% {
    background-color: #FF954C;
  }
  25% {
    background-color: #FF954C;
  }
  50% {
    background-color: #f0ead6;
  }
  75% {
    background-color: #FF954C;
  }
  100% {
    background-color: #FF954C;
  }
}
[gamekey=ember] .UnitHealthBar[affiliation=good] .Fill {
  background-color: #E86C3B;
}
[gamekey=ember] .UnitHealthBar[affiliation=good] .OmegaFill[color=heal] {
  animation-duration: 1s;
  animation-name: pulse-ember-good-heal;
}
@keyframes pulse-ember-good-heal {
  0% {
    background-color: #f0ead6;
  }
  25% {
    background-color: #f0ead6;
  }
  50% {
    background-color: #FF954C;
  }
  75% {
    background-color: #f0ead6;
  }
  100% {
    background-color: #f0ead6;
  }
}
[gamekey=ember] .UnitHealthBar[affiliation=good] .OmegaFill[color=hurt] {
  animation-duration: 2s;
  animation-name: pulse-ember-good-hurt;
}
@keyframes pulse-ember-good-hurt {
  0% {
    background-color: #FF954C;
  }
  25% {
    background-color: #FF954C;
  }
  50% {
    background-color: #f0ead6;
  }
  75% {
    background-color: #FF954C;
  }
  100% {
    background-color: #FF954C;
  }
}
[gamekey=ember] .UnitHealthBar[affiliation=bad] .Fill {
  background-color: #2CD1C9;
}
[gamekey=ember] .UnitHealthBar[affiliation=bad] .Fill .OmegaFill[color=heal] {
  animation-duration: 1s;
  animation-name: pulse-ember-bad-heal;
}
@keyframes pulse-ember-bad-heal {
  0% {
    background-color: #f0ead6;
  }
  25% {
    background-color: #f0ead6;
  }
  50% {
    background-color: #ACFFE5;
  }
  75% {
    background-color: #f0ead6;
  }
  100% {
    background-color: #f0ead6;
  }
}
[gamekey=ember] .UnitHealthBar[affiliation=bad] .Fill .OmegaFill[color=hurt] {
  animation-duration: 2s;
  animation-name: pulse-ember-bad-hurt;
}
@keyframes pulse-ember-bad-hurt {
  0% {
    background-color: #ACFFE5;
  }
  25% {
    background-color: #ACFFE5;
  }
  50% {
    background-color: #f0ead6;
  }
  75% {
    background-color: #ACFFE5;
  }
  100% {
    background-color: #ACFFE5;
  }
}
[gamekey=book] .UnitHealthBar {
  background-color: #0c1a23;
  border-color: #000111;
}
[gamekey=book] .UnitHealthBar .Border:not(:last-child) {
  border-right-color: #000111;
}
[gamekey=book] .UnitHealthBar .Fill {
  background-color: #FF5311;
}
[gamekey=book] .UnitHealthBar .OmegaFill[color=heal] {
  animation-duration: 1s;
  animation-name: pulse-horror-bad-heal;
}
@keyframes pulse-horror-bad-heal {
  0% {
    background-color: #0c1a23;
  }
  25% {
    background-color: #0c1a23;
  }
  50% {
    background-color: #FF5311;
  }
  75% {
    background-color: #0c1a23;
  }
  100% {
    background-color: #0c1a23;
  }
}
[gamekey=book] .UnitHealthBar .OmegaFill[color=hurt] {
  animation-duration: 2s;
  animation-name: pulse-horror-good-hurt;
}
@keyframes pulse-horror-good-hurt {
  0% {
    background-color: #FF5311;
  }
  25% {
    background-color: #FF5311;
  }
  50% {
    background-color: #0c1a23;
  }
  75% {
    background-color: #FF5311;
  }
  100% {
    background-color: #FF5311;
  }
}
[gamekey=book] .UnitHealthBar[affiliation=good] .Fill {
  background-color: #99d7e0;
}
[gamekey=book] .UnitHealthBar[affiliation=good] .OmegaFill[color=heal] {
  animation-duration: 1s;
  animation-name: pulse-horror-good-heal;
}
@keyframes pulse-horror-good-heal {
  0% {
    background-color: #0c1a23;
  }
  25% {
    background-color: #0c1a23;
  }
  50% {
    background-color: #99d7e0;
  }
  75% {
    background-color: #0c1a23;
  }
  100% {
    background-color: #0c1a23;
  }
}
[gamekey=book] .UnitHealthBar[affiliation=good] .OmegaFill[color=hurt] {
  animation-duration: 2s;
  animation-name: pulse-horror-good-hurt;
}
@keyframes pulse-horror-good-hurt {
  0% {
    background-color: #99d7e0;
  }
  25% {
    background-color: #99d7e0;
  }
  50% {
    background-color: #0c1a23;
  }
  75% {
    background-color: #99d7e0;
  }
  100% {
    background-color: #99d7e0;
  }
}
[gamekey=hero] .UnitHealthBar {
  border-color: #000111;
}
[gamekey=hero] .UnitHealthBar .Border:not(:last-child) {
  border-right-color: #000111;
}
[gamekey=hero] .UnitHealthBar[affiliation=good] .Fill {
  background-color: #4086d0;
}
[gamekey=hero] .UnitHealthBar[affiliation=good] .OmegaFill[color=heal] {
  animation-duration: 1s;
  animation-name: pulse-hero-good-heal;
}
@keyframes pulse-hero-good-heal {
  0% {
    background-color: #f0ead6;
  }
  25% {
    background-color: #f0ead6;
  }
  50% {
    background-color: #5b9add;
  }
  75% {
    background-color: #f0ead6;
  }
  100% {
    background-color: #f0ead6;
  }
}
[gamekey=hero] .UnitHealthBar[affiliation=good] .OmegaFill[color=hurt] {
  animation-duration: 2s;
  animation-name: pulse-hero-good-hurt;
}
@keyframes pulse-hero-good-hurt {
  0% {
    background-color: #5b9add;
  }
  25% {
    background-color: #5b9add;
  }
  50% {
    background-color: #f0ead6;
  }
  75% {
    background-color: #5b9add;
  }
  100% {
    background-color: #5b9add;
  }
}
[gamekey=hero] .UnitHealthBar[affiliation=bad] .Fill {
  background-color: #d13b32;
}
[gamekey=hero] .UnitHealthBar[affiliation=bad] .OmegaFill[color=heal] {
  animation-duration: 1s;
  animation-name: pulse-hero-bad-heal;
}
@keyframes pulse-hero-bad-heal {
  0% {
    background-color: #f0ead6;
  }
  25% {
    background-color: #f0ead6;
  }
  50% {
    background-color: #de574f;
  }
  75% {
    background-color: #f0ead6;
  }
  100% {
    background-color: #f0ead6;
  }
}
[gamekey=hero] .UnitHealthBar[affiliation=bad] .OmegaFill[color=hurt] {
  animation-duration: 2s;
  animation-name: pulse-hero-bad-hurt;
}
@keyframes pulse-hero-bad-hurt {
  0% {
    background-color: #de574f;
  }
  25% {
    background-color: #de574f;
  }
  50% {
    background-color: #f0ead6;
  }
  75% {
    background-color: #de574f;
  }
  100% {
    background-color: #de574f;
  }
}
[gamekey=school] .UnitHealthBar,
[gamekey=pirates] .UnitHealthBar {
  border-color: #000111;
  background-color: #080809;
}
[gamekey=school] .UnitHealthBar .Label,
[gamekey=pirates] .UnitHealthBar .Label {
  display: none;
}
[gamekey=school] .UnitHealthBar .Border:not(:last-child),
[gamekey=pirates] .UnitHealthBar .Border:not(:last-child) {
  border-right-color: #000111;
}
[gamekey=school] .UnitHealthBar .Fill,
[gamekey=pirates] .UnitHealthBar .Fill {
  background-color: #48bf5e;
}
[gamekey=school] .UnitHealthBar .OmegaFill[color=heal],
[gamekey=pirates] .UnitHealthBar .OmegaFill[color=heal] {
  animation-duration: 1s;
  animation-name: pulse-pirates-neutral-heal;
}
@keyframes pulse-pirates-neutral-heal {
  0% {
    background-color: #f0ead6;
  }
  25% {
    background-color: #f0ead6;
  }
  50% {
    background-color: #7eed93;
  }
  75% {
    background-color: #f0ead6;
  }
  100% {
    background-color: #f0ead6;
  }
}
[gamekey=school] .UnitHealthBar .OmegaFill[color=hurt],
[gamekey=pirates] .UnitHealthBar .OmegaFill[color=hurt] {
  animation-duration: 2s;
  animation-name: pulse-pirates-neutral-hurt;
}
@keyframes pulse-pirates-neutral-hurt {
  0% {
    background-color: #7eed93;
  }
  25% {
    background-color: #7eed93;
  }
  50% {
    background-color: #f0ead6;
  }
  75% {
    background-color: #7eed93;
  }
  100% {
    background-color: #7eed93;
  }
}
[gamekey=school] .UnitHealthBar[affiliation=good] .Fill,
[gamekey=pirates] .UnitHealthBar[affiliation=good] .Fill {
  background-color: #bf4b3f;
}
[gamekey=school] .UnitHealthBar[affiliation=good] .OmegaFill[color=heal],
[gamekey=pirates] .UnitHealthBar[affiliation=good] .OmegaFill[color=heal] {
  animation-duration: 1s;
  animation-name: pulse-pirates-good-heal;
}
@keyframes pulse-pirates-good-heal {
  0% {
    background-color: #f0ead6;
  }
  25% {
    background-color: #f0ead6;
  }
  50% {
    background-color: #da7368;
  }
  75% {
    background-color: #f0ead6;
  }
  100% {
    background-color: #f0ead6;
  }
}
[gamekey=school] .UnitHealthBar[affiliation=good] .OmegaFill[color=hurt],
[gamekey=pirates] .UnitHealthBar[affiliation=good] .OmegaFill[color=hurt] {
  animation-duration: 2s;
  animation-name: pulse-pirates-good-hurt;
}
@keyframes pulse-pirates-good-hurt {
  0% {
    background-color: #da7368;
  }
  25% {
    background-color: #da7368;
  }
  50% {
    background-color: #f0ead6;
  }
  75% {
    background-color: #da7368;
  }
  100% {
    background-color: #da7368;
  }
}
[gamekey=school] .UnitHealthBar[affiliation=bad] .Fill,
[gamekey=pirates] .UnitHealthBar[affiliation=bad] .Fill {
  background-color: #48bf5e;
}
[gamekey=school] .UnitHealthBar[affiliation=bad] .OmegaFill[color=heal],
[gamekey=pirates] .UnitHealthBar[affiliation=bad] .OmegaFill[color=heal] {
  animation-duration: 1s;
  animation-name: pulse-ember-bad-heal;
}
@keyframes pulse-ember-bad-heal {
  0% {
    background-color: #f0ead6;
  }
  25% {
    background-color: #f0ead6;
  }
  50% {
    background-color: #7edb8f;
  }
  75% {
    background-color: #f0ead6;
  }
  100% {
    background-color: #f0ead6;
  }
}
[gamekey=school] .UnitHealthBar[affiliation=bad] .OmegaFill[color=hurt],
[gamekey=pirates] .UnitHealthBar[affiliation=bad] .OmegaFill[color=hurt] {
  animation-duration: 2s;
  animation-name: pulse-pirates-bad-hurt;
}
@keyframes pulse-pirates-bad-hurt {
  0% {
    background-color: #7edb8f;
  }
  25% {
    background-color: #7edb8f;
  }
  50% {
    background-color: #f0ead6;
  }
  75% {
    background-color: #7edb8f;
  }
  100% {
    background-color: #7edb8f;
  }
}
[gamekey=school] .UnitHealthBar[affiliation=orange] .Fill,
[gamekey=pirates] .UnitHealthBar[affiliation=orange] .Fill {
  background-color: #b46d3d;
}
[gamekey=school] .UnitHealthBar[affiliation=orange] .OmegaFill[color=heal],
[gamekey=pirates] .UnitHealthBar[affiliation=orange] .OmegaFill[color=heal] {
  animation-duration: 1s;
  animation-name: pulse-pirates-orange-heal;
}
@keyframes pulse-pirates-orange-heal {
  0% {
    background-color: #f0ead6;
  }
  25% {
    background-color: #f0ead6;
  }
  50% {
    background-color: #9d5f4a;
  }
  75% {
    background-color: #f0ead6;
  }
  100% {
    background-color: #f0ead6;
  }
}
[gamekey=school] .UnitHealthBar[affiliation=orange] .OmegaFill[color=hurt],
[gamekey=pirates] .UnitHealthBar[affiliation=orange] .OmegaFill[color=hurt] {
  animation-duration: 2s;
  animation-name: pulse-pirates-orange-hurt;
}
@keyframes pulse-pirates-orange-hurt {
  0% {
    background-color: #9d5f4a;
  }
  25% {
    background-color: #9d5f4a;
  }
  50% {
    background-color: #f0ead6;
  }
  75% {
    background-color: #9d5f4a;
  }
  100% {
    background-color: #9d5f4a;
  }
}
[gamekey=school] .UnitHealthBar[affiliation=purple] .Fill,
[gamekey=pirates] .UnitHealthBar[affiliation=purple] .Fill {
  background-color: #49416e;
}
[gamekey=school] .UnitHealthBar[affiliation=purple] .OmegaFill[color=heal],
[gamekey=pirates] .UnitHealthBar[affiliation=purple] .OmegaFill[color=heal] {
  animation-duration: 1s;
  animation-name: pulse-pirates-purple-heal;
}
@keyframes pulse-pirates-purple-heal {
  0% {
    background-color: #f0ead6;
  }
  25% {
    background-color: #f0ead6;
  }
  50% {
    background-color: #645c85;
  }
  75% {
    background-color: #f0ead6;
  }
  100% {
    background-color: #f0ead6;
  }
}
[gamekey=school] .UnitHealthBar[affiliation=purple] .OmegaFill[color=hurt],
[gamekey=pirates] .UnitHealthBar[affiliation=purple] .OmegaFill[color=hurt] {
  animation-duration: 2s;
  animation-name: pulse-pirates-purple-hurt;
}
@keyframes pulse-pirates-purple-hurt {
  0% {
    background-color: #645c85;
  }
  25% {
    background-color: #645c85;
  }
  50% {
    background-color: #f0ead6;
  }
  75% {
    background-color: #645c85;
  }
  100% {
    background-color: #645c85;
  }
}
[gamekey=school] .UnitHealthBar[affiliation=blue] .Fill,
[gamekey=pirates] .UnitHealthBar[affiliation=blue] .Fill {
  background-color: #3577A9;
}
[gamekey=school] .UnitHealthBar[affiliation=blue] .OmegaFill[color=heal],
[gamekey=pirates] .UnitHealthBar[affiliation=blue] .OmegaFill[color=heal] {
  animation-duration: 1s;
  animation-name: pulse-pirates-blue-heal;
}
@keyframes pulse-pirates-blue-heal {
  0% {
    background-color: #f0ead6;
  }
  25% {
    background-color: #f0ead6;
  }
  50% {
    background-color: #5c97c4;
  }
  75% {
    background-color: #f0ead6;
  }
  100% {
    background-color: #f0ead6;
  }
}
[gamekey=school] .UnitHealthBar[affiliation=blue] .OmegaFill[color=hurt],
[gamekey=pirates] .UnitHealthBar[affiliation=blue] .OmegaFill[color=hurt] {
  animation-duration: 2s;
  animation-name: pulse-pirates-blue-hurt;
}
@keyframes pulse-pirates-blue-hurt {
  0% {
    background-color: #5c97c4;
  }
  25% {
    background-color: #5c97c4;
  }
  50% {
    background-color: #f0ead6;
  }
  75% {
    background-color: #5c97c4;
  }
  100% {
    background-color: #5c97c4;
  }
}
